<template>
  <div class="detailPage" ref="page" :class="{'zh':lang!='en_US','accessibility':accessibility}">
    <previewImage
      v-if="showPreview"
      :closeevent="closeEvent"
      :lang="lang"
      :imglist="imglist"
    ></previewImage>
    <div v-if="!showPreview&&accessibility||!accessibility">
      <div class="coverImg" ref="coverImg">
        <img 
          role='none'
          :src="getObject(editorialDetail.langMap, lang).image" 
          @click="previewCoverEvent()" 
        />
      </div>
      <div class="content">
        <div class="category">
          {{ getObject(editorialDetail.langMap, lang).cardTitle }}
        </div>
        <h1 class="title">
          {{ getObject(editorialDetail.langMap, lang).editorialTitle }}
        </h1>
      </div>
      <div v-for="(module,index) in editorialDetail.modules">
        <div class="editorContent" v-if="module.moduleId == 1">
          <ckeditor
            :editor="editor"
            :id="'editor'+index"
            :disabled="true"
            :isReadOnly="true"
            :config="editorConfig"
            v-model="getObject(module.langMap, lang).content"
          ></ckeditor>
        </div>
        <div
          class="editorContent"
          :class="{ iosBigFirst: iosBigFirst }"
          v-if="module.moduleId == 2"
        >
          <ckeditor
            :id="'editor'+index"
            :editor="editor"
            :disabled="true"
            :isReadOnly="true"
            :config="editorConfig"
            v-model="getObject(module.langMap, lang).content"
          ></ckeditor>
        </div>
        <div  v-if="module.moduleId == 3">
          <h2 class="contentTitle">{{ getObject(module.langMap, lang).content }}</h2>
        </div>
        <div class="fullImg imgSection" v-if="module.moduleId == 4">
          <img
            role='none'
            :src="getObject(module.langMap, lang).url"
            @click="previewBigEvent(module)"
          />
          <div class="alt" v-if="getObject(module.langMap, lang).description">
            {{ getObject(module.langMap, lang).description }}
          </div>
          <div 
            style="height:20px" 
            v-if="
              !getObject(module.langMap, lang).description
              &&index<editorialDetail.modules.length-1
              &&editorialDetail.modules[index+1].moduleId!=4
              &&editorialDetail.modules[index+1].moduleId!=6
              &&editorialDetail.modules[index+1].moduleId!=7
            "
          >
          </div>
        </div>
        <div class="video" v-if="module.moduleId == 5">
          <video
            width="100%"
            :preload="getObject(module.langMap, lang).url+'#t=10'"
            :src="getObject(module.langMap, lang).url"
            controls="controls"
          ></video>
        </div>
        <div
          class="towImg imgSection"
          v-if="module.moduleId == 6 && module.urls && module.urls.length > 0"
        >
          <div class="item-table">
            <div class="tdcell pad-r">
              <div
                ref="squareImgL6"
                class="squareImg"
                @click="previewEvent(module.urls)"
              >
                <img
                  role='none'
                  :src="getObject(module.urls[0].langMap, lang).url"
                  @load="loadImage()"
                  ref="imageOne"
                />
              </div>
            </div>
            <div class="tdcell pad-l" v-if="module.urls[1]">
              <div
                ref="squareImgR6"
                class="squareImg tdcell"
                @click="previewEvent(module.urls)"
              >
                <img
                  role='none'
                  :src="getObject(module.urls[1].langMap, lang).url"
                  @load="loadImage()"
                  ref="imageOne"
                />
              </div>
            </div>
          </div>
          <div class="alt" v-if="getObject(module.langMap, lang).description">
            {{ getObject(module.langMap, lang).description }}
          </div>
          <div 
            style="height:20px" 
            v-if="
              !getObject(module.langMap, lang).description
              &&index<editorialDetail.modules.length-1
              &&editorialDetail.modules[index+1].moduleId!=4
              &&editorialDetail.modules[index+1].moduleId!=6
              &&editorialDetail.modules[index+1].moduleId!=7
            "
          >
          </div>
        </div>
        <div
          class="towImg imgSection"
          v-if="module.moduleId == 7 && module.urls && module.urls.length > 0"
        >
          <div class="item-table">
            <div class="tdcell pad-r">
              <div
                ref="squareImgL"
                class="squareImg"
                @click="previewEvent(module.urls)"
              >
                <img
                  role='none'
                  :src="getObject(module.urls[0].langMap, lang).url"
                  @load="loadImage2()"
                  ref="imageOne2"
                />
              </div>
            </div>
            <div class="tdcell pad-l" v-if="module.urls[1]">
              <div
                ref="squareImgR"
                class="squareImg tdcell"
                @click="previewEvent(module.urls)"
              >
                <img
                  role='none'
                  :src="getObject(module.urls[1].langMap, lang).url"
                  @load="loadImage2()"
                  ref="imageOne2"
                />
                <div class="moreImg" hidden aria-hidden="true" v-if="module.urls.length > 2">
                  + {{ module.urls.length - 1 }}
                </div>
              </div>
            </div>
          </div>
          <div class="alt" v-if="getObject(module.langMap, lang).description">
            {{ getObject(module.langMap, lang).description }}
          </div>
          <div 
            style="height:20px" 
            v-if="
              !getObject(module.langMap, lang).description
              &&index<editorialDetail.modules.length-1
              &&editorialDetail.modules[index+1].moduleId!=4
              &&editorialDetail.modules[index+1].moduleId!=6
              &&editorialDetail.modules[index+1].moduleId!=7
            "
          >
          </div>
        </div>
        <div class="quote" v-if="module.moduleId == 8">
          <div class="item-table">
            <div class="tdcell yinhao pad-r">
              <img src="../images/y1.png" />
            </div>
            <div class="tdcell line"><div class="greyLine"></div></div>
          </div>
          <div class="quote-content wrap">
            {{ getObject(module.langMap, lang).quote }}
          </div>
          <div  ref="authorC" style="font-size: 12px;">
            <span ref="author" class="wrap">{{
              getObject(module.langMap, lang).author
            }}</span>
          </div>
          <div class="item-table">
            <div class="tdcell line" style="min-width:100px"><div class="greyLine"></div></div>
            <div class="tdcell yinhao pad-l">
              <img src="../images/y2.png" />
            </div>
          </div>
        </div>
        <div
          class="poiList"
          v-if="
            module.moduleId == 9 && module.events && module.events.length > 0
          "
        >
          <div class="item-table" >
            <div
              class="tdcell "
              style="width: 80px;"
            >
              <div class="poi_icon">
                <img
                  role='none'
                  :src="module.events[0].imageUrl"
                />
              </div>
            </div>
            <div class="tdcell">
              <div class="flexObj">
                <div class="poi_title">
                  {{ getObject(module.events[0].langMap, lang).title }}
                </div>
                <div class="poi_type oneline-box" v-if="module.events[0].startDate">
                  <span v-if="module.events[0].startDate!=module.events[0].endDate">{{$t("message.From") }}</span> 
                  {{ getDateStr(module.events[0].startDate)}}<span v-if="module.events[0].startDate!=module.events[0].endDate">{{$t("message.From1") }}</span>
                </div>
              </div>
            </div>
            <div class="tdcell btnView">
              <div class="btn flexObj">
                <button
                  class="btn_view"
                  v-if="module.events[0].status == 10"
                  @click="callRNEvent(module.events[0].id, 'EVENT')"
                >
                  {{$t("message.View") }}
                </button>
                <button
                  class="btn_view grayView"
                  v-if="module.events[0].status != 10"
                >
                  {{$t("message.View") }}
                </button>
              </div>
            </div>
          </div>
        </div>
        <div
          class="poiDetail"
          v-if="
            module.moduleId == 10 && module.events && module.events.length > 0
          "
        >
          <div class="poi_icon" >
            <img
              role='none'
              :src="module.events[0].imageUrl"
            />
          </div>
          <div class="">
            <div class="poi_title">
              {{ getObject(module.events[0].langMap, lang).title }}
            </div>
          </div>
          <div class="btnView">
            <div class="btn">
              <button
                class="btn_view"
                v-if="module.events[0].status == 10"
                @click="callRNEvent(module.events[0].id, 'EVENT')"
              >
                {{$t("message.View") }}
              </button>
              <button
                class="btn_view grayView"
                v-if="module.events[0].status != 10"
              >
                {{$t("message.View") }}
              </button>
            </div>
          </div>
        </div>
        <div
          class="poiList"
          v-if="module.moduleId == 11 && module.pois && module.pois.length > 0"
        >
          <div class="item-table">
            <div class="tdcell" style="width: 80px;">
              <div class="poi_icon">
                <img 
                  role='none'
                  :src="module.pois[0].imageUrl" 
                />
              </div>
            </div>
            <div class="tdcell">
              <div class="flexObj">
                <div class="poi_title">
                  {{ getObject(module.pois[0].langMap, lang).name }}
                </div>
                <div class="poi_type" >
                  {{getLabel(module.pois[0]) }}
                </div>
              </div>
            </div>
            <div class="tdcell btnView">
              <div class="btn flexObj">
                <button
                  class="btn_view"
                  v-if="module.pois[0].status == 0"
                  @click="callRNEvent(module.pois[0].externalId, 'POI')"
                >
                  {{$t("message.View") }}
                </button>
                <button
                  class="btn_view grayView"
                  v-if="module.pois[0].status != 0"
                >
                  {{$t("message.View") }}
                </button>
              </div>
            </div>
          </div>
        </div>
        <div
          class="poiDetail"
          v-if="module.moduleId == 12 && module.pois && module.pois.length > 0"
        >
          <div class="tdcell poi_icon">
            <img 
              role='none'
              :src="module.pois[0].imageUrl" 
            />
          </div>
          <div class="">
            <div class="poi_title">
              {{ getObject(module.pois[0].langMap, lang).name }}
            </div>
          </div>
          <div class="btnView">
            <div class="btn">
              <button
                class="btn_view"
                v-if="module.pois[0].status == 0"
                @click="callRNEvent(module.pois[0].externalId, 'POI')"
              >
                {{$t("message.View") }}
              </button>
              <button class="btn_view grayView" v-if="module.pois[0].status != 0">
                {{$t("message.View") }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import CKEditor from "@ckeditor/ckeditor5-vue";
Vue.use(CKEditor);

import previewImage from "@/components/previewImage.vue";
import ClassicEditor from '@ckeditor/ckeditor5-build-decoupled-document';
export default {
  data() {
    return {
      data: [
        {
          type: 1,
          data: "",
        },
        {
          type: 1,
          data: "",
        },
      ],
      lang: "en_US",
      editor: ClassicEditor,
      backgroundImg: "",
      styleObject: {},
      editorConfig: {
        toolbar: [],
      },
      editorialDetail: {},
      imglist: [],
      showPreview: false,
      windowHight: 500,
      iosBigFirst: false,
      poiIds:[],
      defaultImage:"",
      accessibility:false,
      expiredIds:[],
    };
  },
  components: {
    previewImage,
  },
  methods: {
    getDetail: function (id) {
      let that = this;
      let preview = false;
      let cmspreview = false;
      if(this.$route.query.preview=='true'){
        preview = true;
      }
      if(this.$route.query.cmspreview){
        cmspreview = true;
      }
      that.api.getEditorialDetail(
        {
          editorialId: id,
          preview: preview,
          cmspreview: cmspreview
        },
        function (data) {
          data.result.modules.forEach(module => {
            if((module.moduleId==11||module.moduleId==12)){
              that.poiIds.forEach(poi =>{
                if(poi.poiId == module.pois[0].externalId){
                  module.pois[0].imageUrl = poi.image;
                }
              })
              if(!module.pois[0].imageUrl){
                module.pois[0].imageUrl = that.defaultImage;
              }
            }
            if((module.moduleId==9||module.moduleId==10)){
              module.events[0].eventVisual.forEach((visual,index) => {
                if(visual.visualType == 'image'&&!module.events[0].imageUrl){
                  module.events[0].imageUrl = that.getObject(module.events[0].eventVisual[index].langMap, that.lang).image
                }
              })
              if(!module.events[0].imageUrl){
                module.events[0].imageUrl = that.defaultImage;
              }
              that.expiredIds.forEach(item =>{
                if(item == module.events[0].id){
                  module.events[0].status = 1;
                }
              })
            }
          })
          that.editorialDetail = data.result;
          that.setStyle();
        }
      );
    },
    getDateStr(date){
      var myDate = new Date(date);
      var fullY = myDate.getFullYear();
      var day = myDate.getDate();
      if(this.lang=="en_US"){
        var month = myDate.toDateString().split( " " )[1];
        return day + " " + month + " "  + fullY
      }else{
        var month = myDate.getMonth()+1;
        return fullY + "年" + month + "月" + day + "日"
      }
    },
    getObject(object, langCode) {
      return !object || object.length == 0
        ? {}
        : object.find((o) => o.langCode == langCode);
    },
    getLabel(poi){
        var str = ""
        this.poiIds.forEach(item =>{
          if(item.poiId == poi.externalId){
            str = this.$i18n.t("message.Venue")
          }
        })
        if(str) return str;
        var venue = poi.venue.split(';')
        venue.forEach(item =>{
          if(item=='dining'){
            if(str){
              str +=" & "
            }
            str += this.$i18n.t("message.Dining")
          }else if(item=="shopping"){
            if(str){
              str +=" & "
            }
            str += this.$i18n.t("message.Shop")
          }else if(item=="activity"){
            if(str){
              str +=" & "
            }
            str += this.$i18n.t("message.Amenities")
          }else if(item=="transport"){
            if(str){
              str +=" & "
            }
            str += this.$i18n.t("message.Transportation")
          }else if(item=="parking"){
            if(str){
              str +=" & "
            }
            str += this.$i18n.t("message.Parking")
          }
        })
        return str;
    },
    setStyle() {
      var that = this;
      setTimeout(function () {
        if (that.$refs.squareImgL) {
          for (var j = 0; j < that.$refs.squareImgL.length; j++) {
            that.$refs.squareImgL[j].style.height =
              (window.innerWidth - 8) / 2 + "px";
            that.$refs.squareImgL[j].style.width =
              (window.innerWidth - 8) / 2 + "px";
          }
        }
        if (that.$refs.squareImgR) {
          for (var k = 0; k < that.$refs.squareImgR.length; k++) {
            that.$refs.squareImgR[k].style.height =
              (window.innerWidth - 8) / 2 + "px";
            that.$refs.squareImgR[k].style.width =
              (window.innerWidth - 8) / 2 + "px";
          }
        }
        if (that.$refs.squareImgL6) {
          for (var j = 0; j < that.$refs.squareImgL6.length; j++) {
            that.$refs.squareImgL6[j].style.height =
              (((window.innerWidth - 8) / 2) * 372) / 279 + "px";
            that.$refs.squareImgL6[j].style.width =
              (window.innerWidth - 8) / 2 + "px";
          }
        }
        if (that.$refs.squareImgR6) {
          for (var k = 0; k < that.$refs.squareImgR6.length; k++) {
            that.$refs.squareImgR6[k].style.height =
              (((window.innerWidth - 8) / 2) * 372) / 279 + "px";
            that.$refs.squareImgR6[k].style.width =
              (window.innerWidth - 8) / 2 + "px";
          }
        }
      }, 500);
      setTimeout(function () {
        that.iosBigFirst = true;
      }, 500);
      setTimeout(function () {
        that.editorialDetail.modules.forEach((item,index) =>{
          if(document.getElementById("editor"+index)){
            document.getElementById("editor"+index).removeAttribute('aria-label');
          }
        })
        // console.log(document.querySelector(".ck-content"))
        // document.getElementById(".ck-content").removeAttribute('aria-label')
      }, 1500);
    },
    callRNEvent(id, type) {
      // var str = 'wkcd://editorial?id='+id+'&type='+type;
      var data = {
        id: id,
        type: type,
      };
      window.ReactNativeWebView.postMessage(JSON.stringify(data));
      // this.iframeEvent(str);
      // window.location.href = str;
      // this.$router.push({ path: '/callAppEvent',query:{id:id,type:type} });
    },
    loadImage(e) {
      var that = this;
      if (that.$refs.imageOne) {
        for (var j = 0; j < that.$refs.imageOne.length; j++) {
          if (
            (that.$refs.imageOne[j].offsetWidth * 372) / 279 >
            that.$refs.imageOne[j].offsetHeight
          ) {
            that.$refs.imageOne[j].style.width = "auto";
            that.$refs.imageOne[j].style.height = "100%";
          }
        }
      }
      setTimeout(function(){
        if (that.$refs.imageOne) {
          for (var j = 0; j < that.$refs.imageOne.length; j++) {
            if (
              (that.$refs.imageOne[j].offsetWidth * 372) / 279 >
              that.$refs.imageOne[j].offsetHeight
            ) {
              that.$refs.imageOne[j].style.width = "auto";
              that.$refs.imageOne[j].style.height = "100%";
            }
          }
        }
      },1000)
      setTimeout(function(){
        if (that.$refs.imageOne) {
          for (var j = 0; j < that.$refs.imageOne.length; j++) {
            if (
              (that.$refs.imageOne[j].offsetWidth * 372) / 279 >
              that.$refs.imageOne[j].offsetHeight
            ) {
              that.$refs.imageOne[j].style.width = "auto";
              that.$refs.imageOne[j].style.height = "100%";
            }
          }
        }
      },2000)
    },
    loadImage2(e) {
      var that = this;
      if (that.$refs.imageOne2) {
        for (var j = 0; j < that.$refs.imageOne2.length; j++) {
          if (
            (that.$refs.imageOne2[j].offsetWidth * 372) / 372 >
            that.$refs.imageOne2[j].offsetHeight
          ) {
            that.$refs.imageOne2[j].style.width = "auto";
            that.$refs.imageOne2[j].style.height = "100%";
          }
        }
      }
      setTimeout(function(){
        if (that.$refs.imageOne2) {
          for (var j = 0; j < that.$refs.imageOne2.length; j++) {
            if (
              (that.$refs.imageOne2[j].offsetWidth * 372) / 372 >
              that.$refs.imageOne2[j].offsetHeight
            ) {
              that.$refs.imageOne2[j].style.width = "auto";
              that.$refs.imageOne2[j].style.height = "100%";
            }
          }
        }
      },1000)
      setTimeout(function(){
        if (that.$refs.imageOne2) {
          for (var j = 0; j < that.$refs.imageOne2.length; j++) {
            if (
              (that.$refs.imageOne2[j].offsetWidth * 372) / 372 >
              that.$refs.imageOne2[j].offsetHeight
            ) {
              that.$refs.imageOne2[j].style.width = "auto";
              that.$refs.imageOne2[j].style.height = "100%";
            }
          }
        }
      },2000)
    },
    previewCoverEvent(){
      var data = [];
      this.editorialDetail.langMap.forEach(item =>{
        item.url = item.image
      })
      data.push({
        langMap:this.editorialDetail.langMap
      })
      this.previewEvent(data);
    },
    previewBigEvent: function (obj) {
      
      var data = [];
      data.push(obj);
      this.previewEvent(data);
    },
    previewEvent(obj, type) {
      var num = 44
      if(this.lang=="en_US"){
        num = 100
      }
      obj.forEach(item => {
        if(this.getObject(item.langMap,this.lang).caption&&this.getObject(item.langMap,this.lang).caption.length>num){
          this.getObject(item.langMap,this.lang).showRead = true;
        }else{
          this.getObject(item.langMap,this.lang).showRead = false;
        }
      })
      this.imglist = obj;
      this.showPreview = true;
      this.callRNEvent(null, "HIDEHEADER");
    },
    closeEvent() {
      this.imglist = [];
      this.showPreview = false;
      setTimeout(()=>{
        this.callRNEvent(null, "SHOWHEADER");
      })
      
    },
    iframeEvent: function (url) {
      var docNode = document;
      var iframe = docNode.createElement("iframe");
      iframe.setAttribute("src", url);
      iframe.setAttribute("style", "display:none");
      docNode.body.appendChild(iframe);
      setTimeout(function () {
        docNode.body.removeChild(iframe);
      }, 200);
    },
  },
  mounted() {
    this.domain = process.env.VUE_APP_DOMAIN;
    this.poiIds = [{
        name: "Art Park",
        venueId: 4,
        poiId: "poi838875000357118",
        image:require("@/images/venue_ap.jpg")
    }, {
        name: "Freespace",
        venueId: 2,
        poiId: "poi381580000538609",
        image:require("@/images/venue_freespace.png")
    }, {
        name: "Xiqu Centre",
        venueId: 1,
        poiId: "poi829936500771191",
        image:require("@/images/venue_xc.jpg")
    }, {
        name: "M+ Pavilion",
        venueId: 6,
        poiId: "poi339741500011457",
        image:require("@/images/venue_M.png")
    }]
    this.defaultImage = require("@/images/default-2-about.png")
    this.$refs.page.style.height = window.innerHeight + "px";
    if(this.$refs.coverImg){
      this.$refs.coverImg.style.height = window.innerWidth + "px";
    }
    
    // this.$refs.page.style.height = this.windowHight +"px";
    // this.$refs.detail.style.height = window.innerHeight +"px";
    if (this.$route.query.lang) {
      this.lang = this.$route.query.lang;
    } else {
      var language = navigator.language;
      if (language == "zh-TW" || language == "zh-HK") {
        this.lang = "zh_HK";
      } else if (language == "zh-CN") {
        this.lang = "zh_CN";
      } else {
        this.lang = "en_US";
      }
    }
    this.$i18n.locale = this.lang;
    if(this.$route.query.accessibilityMode=='true'){
      this.accessibility = true;
    }
    if(this.$route.query.expiredIds){
      this.expiredIds = this.$route.query.expiredIds.split(",");
    }
    console.log(this.expiredIds)
    this.getDetail(this.$route.query.id);
  },
};
</script>